// extracted by mini-css-extract-plugin
export default {"voiceButton":"style-module--voiceButton--ba04e","disclaimer":"style-module--disclaimer--e675b"};